import { onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'
import GetLabel from "foundation/js/getLabel"

export default {
    name: "FVLConfirmDeleteProfile",
    setup() {
        const store = useStore()

        const isSubmitting = computed(()=> store.state.frivillige.is_submitting)
        const continueUrl = computed(() => store.state.main.page_overlay_content_data.continueUrl)
        const userProfileId = computed(() => store.state.main.page_overlay_content_data.userProfileId)
        
        let first, last, close

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        const confirmAction = function () {
            isSubmitting.value = true
            store.dispatch('frivilligprofil/deleteFrivilligprofil', { 
                pageId: store.state.main.page_id,
                id: userProfileId.value,
                continueUrl: continueUrl.value 
            })
            isSubmitting.value = false
        }

        const cancelAction = function () {
            store.dispatch('main/closePageOverlay')
        }

        onMounted(() => {
            first = document.querySelector('.kb-button[data-order="first"]')
            last = document.querySelector('.kb-button[data-order="last"]')
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback(
                {
                    opening() {
                        first.focus()
                    }
                },
                { persistent: true }
            )
        })

        return {
            isSubmitting,
            continueUrl,
            cancelAction,
            confirmAction,
            tabTrap,
            getLabel: (labelKey, params) => GetLabel({ labelKey, labelCollection: 'FVLConfirmDeleteProfile', params })
            
        }
    }
    
}